import {
    Box,
    Collapse,
    FormErrorMessage,
    FormLabel,
    Textarea,
    TextareaProps
} from '@chakra-ui/react'
import { FieldError } from 'react-hook-form'
import { FormControlCustom } from '../InputBuild/styles'

interface TextAreaBuildProps extends TextareaProps {
    label: string
    id: string
    maxLength: number
    placeholder?: string
    required?: boolean
    err: FieldError | undefined
}

export const TextAreaBuild: React.FC<TextAreaBuildProps> = ({
    id,
    maxLength,
    placeholder,
    required,
    err,
    ...props
}) => {
    const handleErrorMessage = (err: FieldError): string => {
        return err.message as string
    }

    return (
        <FormControlCustom isInvalid={!!err} isRequired={required}>
            <Box display="flex" alignItems="center">
                <FormLabel
                    textAlign="inherit"
                    mx={0}
                    htmlFor={id}
                    display="flex"
                    alignItems="center"
                >
                    {props.label}
                </FormLabel>
            </Box>
            <Textarea
                id={id}
                maxLength={maxLength}
                placeholder={placeholder}
                rows={6}
                required={false}
                {...props}
            />
            <Collapse in={!!err} animateOpacity>
                <Box minH="15px">
                    <FormErrorMessage position="relative" mt={1} fontSize="xs">
                        {err && handleErrorMessage(err)}
                    </FormErrorMessage>
                </Box>
            </Collapse>
        </FormControlCustom>
    )
}
